export default "__VITE_ASSET__6kssa3xCT2YlMpIbbRNP$Q__ 80w, __VITE_ASSET__aLISaAY6NSiJFT$6GdtrfA__ 160w";